import {
  WORKFLOW_ACTIVITY_ACTION_CLICKED,
  WORKFLOW_ACTIVITY_ACTION_NOT_CLICKED,
  WORKFLOW_ACTIVITY_ACTION_NOT_OPENED,
  WORKFLOW_ACTIVITY_ACTION_ONE_ACTION,
  WORKFLOW_ACTIVITY_ACTION_OPENED,
  WORKFLOW_ACTIVITY_ACTION_SMS_EXPIRED,
  //
  WORKFLOW_ACTIVITY_ACTION_SMS_NOT_DELIVERED,
  WORKFLOW_ACTIVITY_ACTION_SMS_RECEIVED,
  WORKFLOW_ACTIVITY_ACTION_SMS_REJECTED,
  //
  WORKFLOW_ACTIVITY_ACTION_SMS_SENT,
  WORKFLOW_ACTIVITY_ACTION_TEN_ACTION
} from 'Constants/'
import { Flex, RadioButtonsGroup } from 'mailup-web-components'
import { fetchMessageLinksCallback } from 'Pages/Workflow/recoil/callbacks/callbacks'
import { workflowCommonDataState } from 'Pages/Workflow/recoil/state/data'
import {
  activiyTypeExistingFilterState,
  step2State
} from 'Pages/Workflow/recoil/state/step2'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilState, useRecoilValue } from 'recoil'

import InputAction from './InputAction'
import InputActivityType from './InputActivityType'
import InputActivityValue from './InputActivityValue'
import InputClickedLink from './InputClickedLink'
import InputEmailMessage from './InputEmailMessage'
import InputFilter from './InputFilter'
import InputSmsMessage from './InputSmsMessage'

const activityTypesMsg = [
  WORKFLOW_ACTIVITY_ACTION_OPENED,
  WORKFLOW_ACTIVITY_ACTION_NOT_OPENED,
  WORKFLOW_ACTIVITY_ACTION_CLICKED,
  WORKFLOW_ACTIVITY_ACTION_NOT_CLICKED,
  WORKFLOW_ACTIVITY_ACTION_ONE_ACTION,
  WORKFLOW_ACTIVITY_ACTION_TEN_ACTION
]

const activityTypeMsgWithLinks = [
  WORKFLOW_ACTIVITY_ACTION_CLICKED,
  WORKFLOW_ACTIVITY_ACTION_NOT_CLICKED
]

const activityTypesSms = [
  WORKFLOW_ACTIVITY_ACTION_SMS_SENT,
  WORKFLOW_ACTIVITY_ACTION_SMS_RECEIVED,
  WORKFLOW_ACTIVITY_ACTION_SMS_NOT_DELIVERED,
  WORKFLOW_ACTIVITY_ACTION_SMS_REJECTED,
  WORKFLOW_ACTIVITY_ACTION_SMS_EXPIRED
]

const StartTypeActivity = () => {
  const intl = useIntl()
  const { ActivityType, IdMessage } = useRecoilValue(step2State)

  const { allowedProtocols } = useRecoilValue(workflowCommonDataState)

  const [useExisting, setUseExisting] = useRecoilState(
    activiyTypeExistingFilterState
  )

  const fetchMessageLinks = useRecoilCallback(fetchMessageLinksCallback, [])

  //  load message links
  useEffect(() => {
    fetchMessageLinks()
  }, [IdMessage, ActivityType, allowedProtocols])

  const activityValueTypeOptions = [
    {
      label: intl.formatMessage({
        id: 'Load.AutomationWorkflow.NewFilterActivityLabel'
      }),
      value: 'use-custom',
      'data-mu-test': 'new-filter-option'
    },
    {
      label: intl.formatMessage({
        id: 'Load.AutomationWorkflow.UseExistingFilterActivityLabel'
      }),
      value: 'use-existing',
      'data-mu-test': 'existing-filter-option'
    }
  ]

  const handleChangeActivityValueType = (v) => {
    setUseExisting(v)
  }

  return (
    <>
      <Flex justifyContent='center'>
        <RadioButtonsGroup
          items={activityValueTypeOptions}
          onChange={handleChangeActivityValueType}
          value={useExisting}
        />
      </Flex>

      {useExisting === 'use-existing' ? (
        <>
          <InputFilter />
          <InputAction />
        </>
      ) : (
        <>
          <InputActivityType />

          {activityTypesMsg.includes(ActivityType) && (
            <>
              <InputEmailMessage />

              {activityTypeMsgWithLinks.includes(ActivityType) &&
                IdMessage > 0 && <InputClickedLink />}
            </>
          )}

          {activityTypesSms.includes(ActivityType) && <InputSmsMessage />}

          <InputActivityValue />
        </>
      )}
    </>
  )
}

export default StartTypeActivity
